// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Item__Wrapper_2u9Jn","Text":"Item__Text_1eM4X","Logo":"Item__Logo_3antG","Title":"Item__Title_AQNOm"};